export default __webpack_public_path__ + "static/media/radiant-bright-red.2b230564.jpg";